import { SeatingStrategyPreferredSeating, SeatingStrategyPreferFullTables, SeatingStrategyPenalizeBookedTables, SeatingStrategyPreferHighTableCapacityUsage } from ".";

export class SeatingStrategyBase {
  constructor(seatingStrategyType, matchScoreModifier, unmatchedScoreModifier, policyLevel) {
    this.seatingStrategyType = seatingStrategyType;
    this.matchScoreModifier = matchScoreModifier;
    this.unmatchedScoreModifier = unmatchedScoreModifier;
    this.level = policyLevel;
  }

  static fromJSON(json) {
    if (!json) return undefined;

    if (json.seatingStrategyType) {
      switch (json.seatingStrategyType) {
        case SEATING_STRATEGY_TYPE.PreferredSeating: {
          return SeatingStrategyPreferredSeating.fromJSON(json);
        }
        case SEATING_STRATEGY_TYPE.PreferFullTables: {
          return SeatingStrategyPreferFullTables.fromJSON(json);
        }
        case SEATING_STRATEGY_TYPE.PenalizeBookedTables: {
          return SeatingStrategyPenalizeBookedTables.fromJSON(json);
        }
        case SEATING_STRATEGY_TYPE.PreferHighTableCapacityUsage: {
          return SeatingStrategyPreferHighTableCapacityUsage.fromJSON(json);
        }
        default: {
          return undefined;
        }
      }
    }
    return undefined;
  }
}

export class SEATING_STRATEGY_TYPE {
  static PreferredSeating = 'SeatingStrategyPreferredSeating';
  static PreferFullTables = 'SeatingStrategyPreferFullTables';
  static PenalizeBookedTables = 'SeatingStrategyPenalizeBookedTables';
  static PreferHighTableCapacityUsage = 'SeatingStrategyPreferHighTableCapacityUsage';

  static nameof(strategyType) {
    switch (strategyType) {
      case SEATING_STRATEGY_TYPE.PreferredSeating: {
        return 'Preferred seating policy';
      }
      case SEATING_STRATEGY_TYPE.PreferFullTables: {
        return 'Prefer full tables policy';
      }
      case SEATING_STRATEGY_TYPE.PenalizeBookedTables: {
        return 'Penalize booked tables policy';
      }
      case SEATING_STRATEGY_TYPE.PreferHighTableCapacityUsage: {
        return 'Prefer high table capacity usage';
      }
      default: {
        return 'Unknown';
      }
    }
  }

  static getAll() {
    return [SEATING_STRATEGY_TYPE.PreferredSeating, SEATING_STRATEGY_TYPE.PreferHighTableCapacityUsage];
  }
}
